const getImageUrl = (image: string | null, type: string) => {
    if (!image) return '';
    return `${import.meta.env.VITE_APP_URL}/assets/images/${type}/${image}`;
};
const getGatewayImageUrl = (image: string) => {
    return getImageUrl(image, 'gateway');
};
const getAdminImageUrl = (image: string) => {
    return `${import.meta.env.VITE_APP_URL}/assets/admin/images/profile/${image}`;
};

const siteLogo = (type?: string | null): string => {
    const fileName = type ? `/logo_${type}.png` : '/logo.png';
    // Assuming the logo is always under assets/images/logo_icon
    return getImageUrl(fileName, 'logo_icon');
};

const siteFavicon = (): string => {
    return getImageUrl('/favicon.png', 'logo_icon');
};

const imageTemplateByType = (type: string) => {
    return `${import.meta.env.VITE_APP_URL}/assets/images/${type}/{filename}`;
};

export { getImageUrl, getGatewayImageUrl, getAdminImageUrl, siteLogo, siteFavicon, imageTemplateByType };

